import TourPage from "@/components/TourPage";

export default function KenyaFamily7Day() {
  return (
    <TourPage
      tourId="kenya/family-7-day"
      title="7 Days Magical Kenya Family Safari"
      duration="7 Days / 6 Nights"
      price="Contact for price"
      image="/cubslakenakuru.jpg"
      description="Perfect for families, this 7-day safari adventure takes you through Kenya's most famous wildlife destinations, including Amboseli, Lake Naivasha, and the Masai Mara, with activities suitable for all ages."
      itinerary={[
        {
          day: 1,
          title: "Nairobi to Amboseli",
          description:
            "Begin your family adventure with views of Mt. Kilimanjaro.",
          activities: [
            "Family pickup from Nairobi hotel/airport",
            "Drive to Amboseli National Park",
            "Afternoon game drive with Kilimanjaro views",
            "Evening relaxation at the lodge",
          ],
          accommodation: "Amboseli Lodge",
          meals: "Lunch, Dinner",
        },
        {
          day: 2,
          title: "Amboseli National Park",
          description: "Full day exploring Amboseli's wildlife.",
          activities: [
            "Morning game drive to see elephants",
            "Visit to a Masai village",
            "Afternoon wildlife viewing",
            "Evening nature walk (age appropriate)",
          ],
          accommodation: "Amboseli Lodge",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 3,
          title: "Amboseli to Lake Naivasha",
          description: "Travel to the beautiful Lake Naivasha.",
          activities: [
            "Drive to Lake Naivasha",
            "Afternoon boat ride",
            "Bird watching",
            "Optional visit to Crescent Island",
          ],
          accommodation: "Lake Naivasha Lodge",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 4,
          title: "Lake Naivasha to Masai Mara",
          description: "Journey to the famous Masai Mara.",
          activities: [
            "Morning nature walk",
            "Drive to Masai Mara",
            "Evening game drive",
            "Family-friendly wildlife spotting",
          ],
          accommodation: "Mara Family Lodge",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 5,
          title: "Masai Mara Adventure",
          description: "Family fun in the Masai Mara.",
          activities: [
            "Morning game drive",
            "Interactive wildlife learning session",
            "Visit to a local school (when in session)",
            "Evening game drive",
          ],
          accommodation: "Mara Family Lodge",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 6,
          title: "Masai Mara Experience",
          description: "More family adventures in the Mara.",
          activities: [
            "Optional hot air balloon safari",
            "Game drives",
            "Cultural visit to Masai village",
            "Family bush dinner experience",
          ],
          accommodation: "Mara Family Lodge",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 7,
          title: "Masai Mara to Nairobi",
          description: "Final safari day and return to Nairobi.",
          activities: [
            "Morning game drive",
            "Drive back to Nairobi",
            "Optional visit to Giraffe Center",
            "Drop-off at hotel/airport",
          ],
          meals: "Breakfast, Lunch",
        },
      ]}
      inclusions={[
        "Family-friendly accommodation",
        "All transportation in a safari vehicle",
        "Experienced guide",
        "All park entrance fees",
        "Activities mentioned in itinerary",
        "Bottled water",
        "All meals as specified",
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips and gratuities",
        "Optional activities",
        "Drinks and beverages",
      ]}
    />
  );
}
